import { Card, Col, Collapse, Divider, Radio, Row } from 'antd';
import React, { useState } from 'react';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { pricePackages } from './pricepackages';
import PricePackage, { Currency } from './PricePackage';

const { Panel } = Collapse;
const Pricing = ({
  htmlElement,
  freeTrailLink,
}: {
  htmlElement?: HTMLDivElement | null;
  freeTrailLink?: string;
}): JSX.Element => {
  const { formatMessage } = useIntl();
  const { push } = useRouter();
  const [currency, setCurrency] = useState<Currency>('euro');

  const freeTrailAction = () =>
    freeTrailLink
      ? push(freeTrailLink)
      : htmlElement?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

  const faq: { question: string; answer: string }[] = [
    {
      question: formatMessage({
        defaultMessage: 'What do you mean with "Triggers"?',
        description: 'pricing/faq/q1/question',
      }),
      answer: formatMessage({
        defaultMessage:
          "Every automations has a trigger that let's it execute his magic. We calculate your price based on the triggers",
        description: 'faq/q1/answer',
      }),
    },
    {
      question: formatMessage({
        defaultMessage: 'How do I start my free trail?',
        description: 'pricing/faq/q1/question',
      }),
      answer: formatMessage({
        defaultMessage:
          'Just go to the apps you want to integrate, and start using the magic. From then on, you have 14 days until the first payment period starts',
        description: 'faq/q1/answer',
      }),
    },
    {
      question: formatMessage({
        defaultMessage: 'What if I decide to cancel?',
        description: 'pricing/faq/q1/question',
      }),
      answer: formatMessage({
        defaultMessage: 'You may cancel at any time. We will refund pro rata.',
        description: 'faq/q1/answer',
      }),
    },
    {
      question: formatMessage({
        defaultMessage: 'I have an other question',
        description: 'pricing/faq/q1/question',
      }),
      answer: formatMessage({
        defaultMessage:
          'Use our chat tool in the right corner of this page to ask us a question, or contact us via the contact page',
        description: 'faq/q1/answer',
      }),
    },
  ];

  const packages = Object.values(pricePackages).map((pricePackage) => (
    <Col md={24} lg={12} xl={6} key={pricePackage.key}>
      <PricePackage
        pricePackage={pricePackage}
        currency={currency}
        onFreeTrailActionClick={freeTrailAction}
      />
    </Col>
  ));

  return (
    <IntroBlock
      type="green-top"
      title={formatMessage({
        defaultMessage: `Pricing`,
        description: 'off-the-shelve/pricing/title',
      })}
      description={
        <>
          <Col span={24}>
            <p>
              <FormattedMessage
                defaultMessage="Try for free for one month"
                description="off-the-shelve/pricing/description"
              />
            </p>
          </Col>
          <Col span={24}>
            <Row>
              <Radio.Group
                buttonStyle="solid"
                onChange={(a) => setCurrency(a.target.value)}
                value={currency}
              >
                <Radio.Button value="euro">Euro</Radio.Button>
                <Radio.Button value="dollar">Dollar</Radio.Button>
              </Radio.Group>
            </Row>
          </Col>
          <>{packages}</>
          <Divider />
          <Col md={24}>
            <Card
              title={
                <FormattedMessage
                  defaultMessage="Frequently asked questions"
                  description="pricing/faq/title"
                />
              }
              bordered
            >
              <Collapse style={{ textAlign: 'left' }}>
                {faq.map(({ question, answer }, index) => (
                  <Panel header={question} key={index}>
                    {answer}
                  </Panel>
                ))}
              </Collapse>
            </Card>
          </Col>
        </>
      }
    />
  );
};
export default Pricing;
